import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Heading } from '@campgladiator/cgui-core.atoms.typography'
import { LetsConnectProps } from '../../TrainerBio.d'
import styles from './LetsConnect.module.scss'

const handleSocialButtonClick = (link: string) => {
  window.open(link, '_blank')
}

const LetsConnect = ({
  isMobile,
  socials = [],
  ...props
}: LetsConnectProps) => (
  <section className={styles.wrapper} {...props}>
    <Heading type={isMobile ? 'h4' : 'h5'}>Let's Connect</Heading>
    <div className={styles.buttons}>
      {socials.map((social, index) => (
        <Button
          key={index}
          variation="outline"
          emphasis="secondary"
          size="small"
          icon={
            social.type.toUpperCase() === 'INSTAGRAM'
              ? 'icon-instagram-line'
              : 'icon-facebook-line'
          }
          onClick={() => handleSocialButtonClick(social.link)}
        />
      ))}
    </div>
  </section>
)

export default LetsConnect
